import {observable, action, computed} from "mobx";
import { api } from "../services";

class InstallerProvidersStore {
  @observable providers = [];
  @observable providerAssets = { assets: [], additionalAssets: [] };
  @observable inProgress = false;

  @action
  setInProgress(inProgress) {
    this.inProgress = inProgress;
  }

  @action
  loadInstallerProviders() {
    this.inProgress = true;
    return api({ action: "get installer providers" }).then(providers => {
      if (providers) this.providers = providers;
      else this.providers = [];
      this.inProgress = false;
    });
  }

  @action
  loadInstallerProviderAssets(providerId) {
    this.inProgress = true;
    return api({ action: "get installer provider assets" }, providerId).then(assets => {
      if (assets) this.providerAssets = assets;
      else this.providers = [];
      this.inProgress = false;
    });
  }

  @action
  resetInstallerProviderAssets() {
    this.providerAssets = { assets: [], additionalAssets: [] };
  }

  @action
  resetInstallerProviders() {
    this.providers = [];
  }

  @computed
  get providerAssetsWithVehicleType() {
    return this.providerAssets.assets.map(a => {
      return {
        imei: a.imei,
        vehicleType: !a.vehicleType ? 'car' : a.vehicleType
      }
    });
  }

  @computed
  get providerAdditionalAssetsWithVehicleType() {
    return this.providerAssets.additionalAssets.map(a => {
      return {
        imei: a.imei,
        vehicleType: !a.vehicleType ? 'car' : a.vehicleType
      }
    });
  }
}

export default new InstallerProvidersStore();



// WEBPACK FOOTER //
// ./src/stores/installerProvidersStore.js